module.exports = __webpack_public_path__ + "static/1984-2-4f404e5b85af4832e995e10b1613acb3.png";